import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  deleteProvidentFunds,
  getProvidentFunds,
  getDepartments,
  getProfitCenter,
  insertProvidentFunds,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";

export default function ProvidentFund() {
  const UID = getSecureItem("userId");

  const [addProvidentFundModal, setAddProvidentFundModal] = useState(false);
  const [editProvidentFundModal, setEditProvidentFundModal] = useState(false);
  const [providentFunds, setProvidentFunds] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [profitCenters, setProfitCenters] = useState([]);
  const [department, setDepartment] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deletePfTypeId, setDeletePfTypeId] = useState(null); // Correct naming convention
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [isPfAdded, SetIsPfAdded] = useState(Boolean)
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [providentFundData, setProvidentFundData] = useState({
    Id: "",
    Employee: "",
    Employer: "",
    EPS: "",
    EPF: "",
    EPFMinLimit: "",
    EPSMinLimit: "",
    EPSLimit: "",
    EDLICharge: "",
    EDLIAdminCharge: "",
    AdminCharge: "",
    ProfitCenterId: "",
    Esicontibution:"",
    EsiLimint:"",
    pfLimit:"",

    UserId: UID,
  });
  console.log("--------------->", providentFundData);

  const openAddProvidentFundModal = () => {
    setProvidentFundData({
      Id: "",
      Employee: "",
      Employer: "",
      EPS: "",
      EPF: "",
      EPFMinLimit: "",
      EPSMinLimit: "",
      EPSLimit: "",
      EDLICharge: "",
      EDLIAdminCharge: "",
      AdminCharge: "",
      ProfitCenterId: "",
      EsiLimint:"",
      pfLimit:"",
      UserId: UID,
    });
    setAddProvidentFundModal(!addProvidentFundModal);
  };

  const openEditProvidentFundModal = (data) => {
    console.log("data", data);
    // profitcenter id name
    const ProfitCenterName = profitCenters.find((item) => {
      console.log(profitCenters, "crProfit");

      if (item.Id == data?.ProfitCenterId) {
        return item?.Name;
      }
    });
    console.log("ProfitCenterName", ProfitCenterName);

    // departement ID
    const DepartmentName = department.find((item) => {
      console.log(department, "department");

      if (item.Id == data?.DepartmentId) {
        return item?.Name;
      }
    });
    console.log("DepartmentName", DepartmentName);

    setEditProvidentFundModal(!editProvidentFundModal);
    setProvidentFundData({
      ...data,
      ProfitCenterId: data?.ProfitCenterId,
      DepartmentId: data?.DepartmentId,
      ProfitCenter: ProfitCenterName?.Name,
      Department: DepartmentName?.Name,
      EPSMinLimit:data?.EPSMinLimit,
      Esicontibution:data?.Esicontibution,
      EsiLimint:data?.EsiLimint,
      pfLimit:data?.pfLimit,
      UserId: UID || "",
    });
  };

  const fetchProvidentFunds = async () => {
    try {
      const data = await getProvidentFunds(UID);
      console.log(data.data.data, "Fetched data");
      setProvidentFunds(data.data.data);
      setIsFilterVisible(false)
      console.log(providentFunds, "Provident");
    } catch (error) {
      console.error("Error fetching providentFunds", error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProvidentFundData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await insertProvidentFunds(providentFundData);
      if (response?.data?.StatusCode === 200) {
        toast.success(response.data.message);
        fetchProvidentFunds(); // Refresh the provident funds list
        openAddProvidentFundModal(); // Close the modal
      } else {
        toast.warn(response?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("error", error);
      if (error?.response?.data?.details) {
        console.log(error, "ckeck");

        toast.error(error.response.data.details || "An error occurred.");
      } else {
        toast.error("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await insertProvidentFunds(providentFundData);

      // Check if response indicates success
      if (response?.data?.StatusCode === 200) {
        toast.success("Provident Fund updated successfully");
        fetchProvidentFunds(); // Refresh the provident funds list
        openEditProvidentFundModal(); // Close the modal
      } else {
        toast.error(
          response?.data?.message || "Failed to update Provident Fund."
        );
      }
    } catch (error) {
      console.error("Error adding providentFund:", error);
      toast.error(
        "An error occurred while updating Provident Fund. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (providentFundId) => {
    const removeData = { Id: providentFundId, TableName: "PfSetting" };
    try {
      const res = await deleteProvidentFunds(removeData, UID);
      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Provident fund deleted Successfully");
          fetchProvidentFunds(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Provident fund  ");
      }
    } catch (error) {
      // Check for specific error status and handle gracefully
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting PayScale .";
        toast.error("Provident fund  already using cannot delete");
      } else {
        console.error("Error removing Provident fund :", error);
        toast.error("Error deleting Provident fund  . Please try again.");
      }
    }
  };

  const openModal = (payScaleId) => {
    setDeletePfTypeId(payScaleId);
    setIsModalOpen(true);
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false);
    setDeletePfTypeId(null);
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    if (deletePfTypeId) {
      handleDelete(deletePfTypeId); // Ensure handleDelete is defined correctly
    }
    closeModal();
  };

  const clearData = () => {
    setProvidentFundData({
      Id: "",
      Employee: "",
      Employer: "",
      EPS: "",
      EPF: "",
      EPFMinLimit: "",
      EPSMinLimit: "",
      EPSLimit: "",
      EDLICharge: "",
      EDLIAdminCharge: "",
      AdminCharge: "",
      ProfitCenterId: "",
      Esicontibution:"",
      pfLimit:"",
      EsiLimint:"",
      UserId: UID,
    });
  };

  const clearDataForEdit = () => {
    setProvidentFundData((ref) => ({
      ...ref, // Spread the previous state
      Employee: "",
      Employer: "",
      EPS: "",
      EPF: "",
      EPFMinLimit: "",
      EPSMinLimit: "",
      EPSLimit: "",
      EDLICharge: "",
      EDLIAdminCharge: "",
      AdminCharge: "",
      ProfitCenterId: "",
      Esicontibution:"",
      EsiLimint:"",
      pfLimit:"",
      UserId: UID,
    }));
  };

  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Employee",
      selector: (row) => row.Employee || "",
      sortable: true,
    },
    {
      name: "Employer",
      selector: (row) => row.Employer || "",
      sortable: true,
    },
    {
      name: "EPS",
      selector: (row) => row.EPS || "",
      sortable: true,
    },
    {
      name: "EPF",
      selector: (row) => row.EPF || "",
      sortable: true,
    },
    {
      name: "EPS Min Limit",
      selector: (row) => row.EPSMinLimit || "",
      sortable: true,
    },
    {
      name: "EPF Min Limit",
      selector: (row) => row.EPFMinLimit || "",
      sortable: true,
    },
    {
      name: "EPS Limit",
      selector: (row) => row.EPSLimit || "",
      sortable: true,
    },
    {
      name: "EDLI Charge",
      selector: (row) => row.EDLICharge || "",
      sortable: true,
    },
    {
      name: "EDLI Admin Charge",
      selector: (row) => row.EDLIAdminCharge || "",
      sortable: true,
    },
    {
      name: "Admin Charge",
      selector: (row) => row.AdminCharge || "",
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditProvidentFundModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];
  
  const filteredItems = dataFilter.filter((item) => {
    const searchText = filterText.toLowerCase();
    // Check if any field contains the search text
    return Object.values(item).some(
      (value) => value && value.toString().toLowerCase().includes(searchText)
    );
  });

  const subHeaderComponentMemo = useMemo(() => {

  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    setLoading(true);
    fetchProvidentFunds();
  }, []);

  useEffect(() => {
    if (providentFunds && providentFunds.length > 0) {
      const updatedData = providentFunds.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Employee: item.Employee || "",
        Employer: item.Employer || "",
        EPS: item.EPS || "",
        EPF: item.EPF || "",
        EPSMinLimit: item.EPSMinLimit || "",
        EPFMinLimit: item.EPFMinLimit || "",
        EPSLimit: item.EPSLimit || "",
        EDLICharge: item.EDLICharge || "",
        EDLIAdminCharge: item.EDLIAdminCharge || "",
        AdminCharge: item.AdminCharge || "",
        ProfitCenterId: item.ProfitCenterId || "",
        Esicontibution:item.Esicontibution||"",
        EsiLimint:item.EsiLimint||"",
        pfLimit:item.pfLimit||"",
        UserId: item.UserId || "",
      }));
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [providentFunds]);

  // profit center fetch
  useEffect(() => {
    const fetchProfitCenters = async () => {
      try {
        const response = await getProfitCenter(UID);
        const responses = await getDepartments(UID);

        setDepartment(responses.data.data);
        console.log(department, "dept");

        setProfitCenters(response.data.data);
        console.log(profitCenters, "pro");
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchProfitCenters();
  }, []);

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Provident Fund?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}


      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Provident Fund" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search here..."
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddProvidentFundModal}
            className="btn btn-primary"
            // disabled={dataFilter?.length >= 1}
            title={dataFilter?.length >= 1 ? "PF already added" : ""}
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={providentFunds} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {/* 
      ==========================================================Add============================ */}
      {addProvidentFundModal && (
        <>
          <form onSubmit={handleSubmit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Add Provident Fund
                  <span className="absolute top-0 right-0">
                    <button
                      onClick={openAddProvidentFundModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
                  <p style={{ color: 'red', margin: 0 }}>Note:</p>
                  <p style={{ color: 'black', margin: 0 }}>(All values are in percentage)</p>
                </div>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh]">
                  <div className="grid grid-cols-2 gap-10">
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Employee <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="Employee"
                        name="Employee"
                        placeholder="Employee"
                        value={providentFundData.Employee}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Employer <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="Employer"
                        name="Employer"
                        placeholder="Employer"
                        value={providentFundData.Employer}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPS <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="EPS"
                        name="EPS"
                        placeholder="EPS"
                        value={providentFundData.EPS}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPF <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="EPF"
                        name="EPF"
                        placeholder="EPF"
                        value={providentFundData.EPF}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>



                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPS Min Limit <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="EPSMinLimit"
                        name="EPSMinLimit"
                        placeholder="EPSMinLimit"
                        value={providentFundData.EPSMinLimit}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPF Min Limit <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="EPFMinLimit"
                        name="EPFMinLimit"
                        placeholder="EPFMinLimit"
                        value={providentFundData.EPFMinLimit}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPS Limit (Enter amount only)<span style={{ color: "red" }}>*</span>
                      </label>

                      <input
                        type="number"
                        id="EPSLimit"
                        name="EPSLimit"
                        placeholder="EPSLimit"
                        value={providentFundData.EPSLimit}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EDLI admin charge <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="EDLIadmincharge"
                        name="EDLIAdminCharge"
                        placeholder="EDLIadmincharge"
                        value={providentFundData.EDLIAdminCharge}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EDLI Charge <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="EDLICharge"
                        name="EDLICharge"
                        placeholder="EDLICharge"
                        value={providentFundData.EDLICharge}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Admin Charge <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="AdminCharge"
                        name="AdminCharge"
                        placeholder="AdminCharge"
                        value={providentFundData.AdminCharge}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        ESI_Employer Contibution <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="Esicontibution"
                        name="Esicontibution"
                        placeholder="ESI"
                        value={providentFundData.Esicontibution}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                      />
                    </div>
                     <div className="form-group flex flex-col gap-2">
                      <label>
                        ESI Min Limit (Enter amount only)<span style={{ color: "red" }}>*</span>
                      </label>

                      <input
                        type="number"
                        id="EsiLimint"
                        name="EsiLimint"
                        placeholder="EsiLimint"
                        value={providentFundData.EsiLimint}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Pf Min Limit (Enter amount only)<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="pfLimit"
                        name="pfLimit"
                        placeholder="pfLimit"
                        value={providentFundData.pfLimit}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    {/* <div className="form-group flex flex-col gap-2">
                      <label>
                        Profit Center <span style={{ color: "red" }}>*</span>
                      </label>
                      <select

                        name="ProfitCenterId"
                        value={providentFundData.ProfitCenterId}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"

                      >
                        <option value="" >
                          Select Profit Center
                        </option>
                        {profitCenters.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>

                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button className="btn btn-primary" disabled={loading}>
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div
            // onClick={openAddProvidentFundModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
      {/* 
      ===========================================================edit============================ */}
      {editProvidentFundModal && (
        <>
          <form onSubmit={handleEdit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Edit Provident Fund
                  <span className="absolute top-0 right-0">
                    <button
                      type="button"
                      onClick={openEditProvidentFundModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[70vh] ">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Employee <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="Employee"
                        name="Employee"
                        placeholder="Employee"
                        value={providentFundData.Employee}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Employer <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="Employer"
                        name="Employer"
                        placeholder="Employer"
                        value={providentFundData.Employer}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPS <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="EPS"
                        name="EPS"
                        placeholder="EPS"
                        value={providentFundData.EPS}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPF <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="EPF"
                        name="EPF"
                        placeholder="EPF"
                        value={providentFundData.EPF}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>



                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPS Min Limit <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="EPSMinLimit"
                        name="EPSMinLimit"
                        placeholder="EPSMinLimit"
                        value={providentFundData.EPSMinLimit}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPF Min Limit <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="EPFMinLimit"
                        name="EPFMinLimit"
                        placeholder="EPFMinLimit"
                        value={providentFundData.EPFMinLimit}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EPS Limit (Enter amount only)<span style={{ color: "red" }}>*</span>
                      </label>

                      <input
                        type="number"
                        id="EPSLimit"
                        name="EPSLimit"
                        placeholder="EPSLimit"
                        value={providentFundData.EPSLimit}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EDLI Admin Charge <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="EDLIAdminCharge"
                        name="EDLIAdminCharge"
                        placeholder="EDLIAdminCharge"
                        value={providentFundData.EDLIAdminCharge}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        EDLI Charge <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="EDLICharge"
                        name="EDLICharge"
                        placeholder="EDLICharge"
                        value={providentFundData.EDLICharge}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Admin Charge <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="AdminCharge"
                        name="AdminCharge"
                        placeholder="AdminCharge"
                        value={providentFundData.AdminCharge}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        ESI_Employer Contibution <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="Esicontibution"
                        name="Esicontibution"
                        placeholder="ESI"
                        value={providentFundData.Esicontibution}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                      />
                    </div>
                      <div className="form-group flex flex-col gap-2">
                      <label>
                        ESI Min Limit (Enter amount only)<span style={{ color: "red" }}>*</span>
                      </label>

                      <input
                        type="number"
                        id="EsiLimint"
                        name="EsiLimint"
                        placeholder="EsiLimint"
                        value={providentFundData.EsiLimint}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                     <div className="form-group flex flex-col gap-2">
                      <label>
                        Pf Min Limit (Enter amount only)<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="pfLimit"
                        name="pfLimit"
                        placeholder="pfLimit"
                        value={providentFundData.pfLimit}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    {/* <div className="form-group flex flex-col gap-2">
                      <label>
                        Profit Center <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="ProfitCenterId"
                        value={providentFundData.ProfitCenterId}
                        onChange={handleChange}
                        required
                        className="overflow-hidden appearance-none"
                      >
                        <option key="" value="">
                          {providentFundData.Name}
                        </option>
                        {profitCenters.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Edit"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openEditProvidentFundModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
